/** Asset of
     theme.liquid
     hso-hello-google-analytics-backup-theme.liquid
     theme-profitjs-backup.liquid
 layouts
 */

$(document).ready(function(){
  // custom variant js
//   $('.card').each(function(){
//     var selected_value = $(this).find('.variant-option-list input[type="radio"]:checked').val();
//     if( selected_value != undefined ){
//       var v_id = $(this).find('.variant-option-list input[type="radio"]:checked').attr('variant-id');
//       $(this).find('.variant-dropdown .selected-value').text(selected_value);
//       $(this).find('input[name="id"]').val(v_id);
//     }
//   });
  
  /*$(document).on('click', '.variant-dropdown .selected-value', function(){
    $('.card').removeClass('dropdown_active');
  	$(this).parents('.card').addClass('dropdown_active');
  });
  
  $(document).on('mouseleave ontouchmove', '.variant-option-list', function(){
  	$(this).parents('.card').removeClass('dropdown_active');
  });
  
  $(document).on('change', '.variant-option-list input[type="radio"]', function(){
  	var dropdown_value= $(this).val();
    if( dropdown_value != undefined ){
      $(this).parents('.card').find('.selected-value').text(dropdown_value);
      $(this).parents('.card').removeClass('dropdown_active');
      var v_id = $(this).attr('variant-id');
      $(this).parents('.card').find('input[name="id"]').val(v_id);
    }
  });*/

  /*
  $('.product-mobile-slider').flickity({
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    watchCss: true,
    prevNextButtons: false,
    wrapAround: true
  });
  */


//  $('.slider-button--prev').click(function(){
//    $('.product-mobile-slider').flickity('previous', true, false);
//  })
//
//  $('.slider-button--next').click(function(){
//    $('.product-mobile-slider').flickity('next');
//  })


  window.addEventListener('pageshow', (event) => {
    // only true when restoring from the bfcache
    if (event.persisted) {
      location.reload();
    }
  });

  window.addEventListener('popstate', () => {
    // only when clicking back/forward
    location.reload();
  });

  
  $('.addcart-variant .select select').on('change', function(e){
  	var can_price =$(this).find(':selected').attr('data-price');
    $(this).parents('.card').find('.can-per-price').text(can_price);
    //console.log('can_price', can_price)
    
  });
  
  
  $('.product-custom-options .input-option').click(function(){
    if($(this).hasClass('disable')){
      $('.product-form__submit.button').addClass('disable');
    	$('.product-form__submit.button span').text('Out of stock');
    }else{
    	  $('.product-form__submit.button span').text('Add to cart');
      	$('.product-form__submit.button').removeClass('disable');
    }
  });
  
  $('.close-announcement').click(function(){
  	$('#shopify-section-announcement-bar').hide();
  });
  var policy_url = (window.location.href).split('pages/');
  
  $('.policy-left .page-links a').each(function(){
  	var policy_href = $(this).attr('href').split('pages/');
    if( policy_href[1] ==  policy_url[1]){
		$(this).addClass('active');
    }
  });



// OLD CUSTOM COOKIE BAR
//
//  if($('.cookie-banner-block').length > 0){
//  var cookieContent = getCookie('cookieContent');
//  if (cookieContent) {
//        $('.cookie-banner-block').removeClass('cookie-on');
//    }else{
//    	$('.cookie-banner-block').addClass('cookie-on');
//    }
//  
//    $('.cookie-banner-block .accept-btn').on('click', function(e){
//      	setCookie('cookieContent','dismiss',365);
//        $('.cookie-banner-block').removeClass('cookie-on');
//    });
//   
//   $('.cookie-banner-block .discard-btn').on('click', function(e){
//      	setCookie('cookieContent','dismiss',1);
//        $('.cookie-banner-block').removeClass('cookie-on');
//    });
//  }
// 



  $('a[href^="#"]').on('click', function(e){
    e.preventDefault();
    if( $($(this).attr('href')).length > 0 ){
      var section_offset = $($(this).attr('href')).offset().top - 64;
      //console.log(section_offset)
      $('html, body').animate({
          scrollTop: section_offset
      }, 500);
    }
  });
  if($('.subscription-section').length > 0){
    
      // cans modal open

      $('.subscription-variant-item .example-link').on('click', function(){

        var cans_id = $(this).attr('id');
        $(`div[modal-id="${cans_id}"]`).toggleClass('active');
      });

      $('.cans-modal, .cans-modal .cm-close').on('click', function(){
        $('.cans-modal').removeClass('active');
      });

      $('.cans-modal .cans-modal-wrapper').on('click', function(e){
        e.stopPropagation()
        //$('body').toggleClass('modal-open');
      });
    
      $('.subscription-variant-box input').on('click', function() {
          var frequency_offset = $('#subscription-frequency').offset().top - 64;
          $('html, body').animate({
              scrollTop: frequency_offset
          }, 500);
      })
    
    
      $('.subscription-frequency-item').hide();
      var product_handle = $('.subscription-variant-box input:checked').attr('varint-product-handle');
      $(`label[product-handle="${product_handle}"]`).show();
      $('.subscription-frequency-item:first-child').find('input').attr('checked', true);
    
      var product_discount = $('.subscription-frequency-item input:checked').parent('.subscription-frequency-item').attr('data-discount');
      if( product_discount != undefined ){
      	$('.delivery-discount').text(`(You are saving ${product_discount} / Delivery)`)
      }
      //var variant_value = $('input[name=variant]:checked').val();
      var variant_value = $('.subscription-frequency-item input:checked').parent('.subscription-frequency-item').attr('variant-id');
      var subscribe_product_id = $('input[name=variant]:checked').attr('product-id');
      var variant_text = $('input[name=variant]:checked').attr('variant-text');
      //var variant_price = $('input[name=variant]:checked').next('.variant-text').find('.sv-price').text();
      var variant_price = $('.subscription-frequency-item input:checked').parent('.subscription-frequency-item').attr('data-price');
      var frequency_value = $('input[name=frequency]:checked').val();
      var frequency_text = $('input[name=frequency]:checked').attr('data-text');
      

      if ( variant_value != undefined && frequency_value != undefined){
        $('.subscription-bottom-box .sf-text').html(`${variant_text}`)
        $('.subscription-bottom-box .sf-fr-text').html(`${frequency_text}`)

        $('.product-form input[name=id]').val(variant_value);
        $('.product-form input[name=selling_plan]').val(frequency_value);
        //$('.subscription-bottom-box h3').text('Your Subscription:');
        $('.subscription-bottom-box .delivery-price').text(variant_price);
        
        $('.subscription-bottom-box .product-form input[name="id"]').val(variant_value)
        $('.subscription-bottom-box .product-form input[name="selling_plan"]').val(frequency_value)
        $('.subscription-bottom-box .product-form input[name="id"]').attr('data-productid', subscribe_product_id)

        $('.subscription-bottom-box').addClass('enable');
      }else{
      	$('.subscription-bottom-box').removeClass('enable');
      }

      $('.subscription-variant-box input').on('change', function() {
        //$('input[name=variant]:checked').val();
        $('.subscription-variant-box').removeClass('selected');
        $(this).parent().addClass('selected');
		
        $('.subscription-frequency-item').hide();
        var product_handle = $('.subscription-variant-box input:checked').attr('varint-product-handle');
        $(`label[product-handle="${product_handle}"]`).show();
        
        $('input[name=frequency]').attr('checked', false);
        $('.subscription-bottom-box .sf-fr-text').html('');
        $('.delivery-discount').text('');
        $('.subscription-bottom-box .delivery-price').text('');
        
        
        
       
      });

      $('.subscription-frequency-item input').on('click', function() {
         
        var subscription_offset = $('.subscription-bottom').offset().top - 64;
        $('html, body').animate({
            scrollTop: subscription_offset
        }, 500);
      });      


      $('.subscription-frequency-item input').on('change', function() {
         //$('input[name=variant]:checked').val();
        $('.subscription-frequency-item').removeClass('selected');
        $(this).parent().addClass('selected');
        
      });

      $('.subscription-frequency-list').on('change',function(){
        var variant_value = $('.subscription-frequency-item input:checked').parent('.subscription-frequency-item').attr('variant-id');
        var variant_text = $('input[name=variant]:checked').attr('variant-text');
       //var variant_price = $('input[name=variant]:checked').next('.variant-text').find('.sv-price').text();
        var variant_price = $('.subscription-frequency-item input:checked').parent('.subscription-frequency-item').attr('data-price');
        var frequency_text = $('input[name=frequency]:checked').attr('data-text');
        $('.subscription-bottom-box .delivery-price').text(variant_price);
        
        var product_handle = $('.subscription-variant-box input:checked').attr('varint-product-handle'); 
	    var frequency_value = $(`.subscription-frequency-item[product-handle="${product_handle}"] input:checked`).val();
        var product_discount = $('.subscription-frequency-item input:checked').parent('.subscription-frequency-item').attr('data-discount');
        if( product_discount != undefined ){
          $('.delivery-discount').text(`(You are saving ${product_discount} / Delivery)`)
        }
        
        if ( frequency_value != undefined){
            $('.subscription-bottom-box .sf-text').html(`${variant_text}`)
            $('.subscription-bottom-box .sf-fr-text').html(`${frequency_text}`)
            $('.subscription-bottom-box').addClass('enable');
            
            $('.subscription-bottom-box .product-form input[name="id"]').val(variant_value)
            $('.subscription-bottom-box .product-form input[name="selling_plan"]').val(frequency_value)
           
        }else{
           $('.subscription-bottom-box').removeClass('enable');
           
        }
      });
  }
  
//   $('.subscription-bottom .subscription-bttn').on('click',function(){
//   	 var variant_id = $('input[name=variant]:checked').val();
//      var qty = 1;
//      var product_handle = $('.subscription-variant-box input:checked').attr('varint-product-handle'); 
//      var selling_plan = $(`.subscription-frequency-item[product-handle="${product_handle}"] input:checked`).val();
//      var product_discount = $('.subscription-frequency-item input:checked').parent('.subscription-frequency-item').attr('data-discount');
//      if( product_discount != undefined ){
//       	$('.delivery-discount').text(`(You are saving ${product_discount} / Delivery)`)
//       } 
     
//      if(selling_plan != undefined ){
//          addItemToCart(variant_id,qty, selling_plan);
//      }
//   });
  
  
//   function addItemToCart(variant_id, qty, selling_plan) {
//     data = {
//       "id": variant_id,
//       "quantity": qty,
//       "selling_plan": selling_plan
//     }
//     jQuery.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: data,
//       dataType: 'json',
//       success: function() { 
//         window.location.href = '/checkout'; 
//       }
//     });
//   }
  
  
  
  // mini cart open close 
  $('body').on('click', function(){
  	$('.mini-cart').removeClass('open');
    $('body').removeClass('mini-cart-overlay');
  });
  $('#cart-icon-bubble').on('click', function(e){
    e.preventDefault();
    $('.mini-cart').toggleClass('open');
    $('body').toggleClass('mini-cart-overlay');
  });
  
//   $(document).on('click', '.view_cart_link', function(e){
//     e.preventDefault();
//     $('.mini-cart').toggleClass('open');
//     $('body').toggleClass('mini-cart-overlay');
//   });
  
  
  $('.mini-cart, .top-menu-cart-icon').on('click', function(e){
  	e.stopPropagation();
    //return false
  });
  $('.mini-cart .title-wrapper-with-link').on('click', function(){
    $('.mini-cart').removeClass('open');
    $('body').removeClass('mini-cart-overlay');
  });
  
  // product reveiw modal
  $('.product-rating, .review-section .close-btn').on('click', function(){
    $('body').toggleClass('modal-open');
  });
  
  $('.review-section').on('click', function(){
    $('body').toggleClass('modal-open');
  });
  
  $('.review-section .page-width').on('click', function(e){
    e.stopPropagation()
    //$('body').toggleClass('modal-open');
  });
  
  // customer link
  $('.forgot-btn').on('click', function(e){
  	e.preventDefault();
    $('.customer-form-right .login-form').css('display','none');
    $('.customer-form-right .forgot-form').css('display','flex');
    $('.customer-form-left .form-links a').css('display','none');
    $('.password-cancel-btn').show();
  });
  
  $('.password-cancel-btn').on('click', function(e){
  	e.preventDefault();
    $('.customer-form-left .form-links a').css('display','flex');
    $('.customer-form-right .login-form').css('display','flex');
    $('.customer-form-right .forgot-form').css('display','none');
    $(this).hide();
  });
  
  $('.address-right .edit-button').on('click', function(e){
  	e.preventDefault();
    
    $(this).parents('li').toggleClass('active');
  });
  
  $('button[type="reset"]').on('click', function(e){
  	$(this).parents('li').toggleClass('active');
  });
  
  
  
  // custom short item
  var c_url= location.href; 
  var sort_value = c_url.split('sort_by=');
  if( sort_value[1] == 'title-descending' ){
    $('[data-value="title-descending"]').find('input').val('title-ascending');
    option_value = $('[data-value="title-ascending"]').attr('data-value', 'title-descending');
    $('[data-value="title-ascending"]').addClass('active');
  }
  if( sort_value[1] == 'price-descending' ){
    $('[data-value="price-descending"]').find('input').val('price-ascending');
    option_value = $('[data-value="price-ascending"]').attr('data-value', 'price-descending');
    $('[data-value="price-ascending"]').addClass('active');
  }
  if( sort_value[1] == 'created-descending' ){
    $('[data-value="created-descending"]').find('input').val('created-ascending');
    option_value = $('[data-value="created-ascending"]').attr('data-value', 'created-descending');
    $('[data-value="created-ascending"]').addClass('active');
  }
  
  $(document).on('click', '.sort-filter, .sort-active-text', function(){
  	$(this).parents('.facets__form').toggleClass('sort-open');
  })
  
  $('.custom-sort-item label').each(function(){
    	var option_value = $(this).attr('data-value');
        
        if ( sort_value[1] == option_value){
			$(this).addClass('active');
        }
    	if( $(this).hasClass('active')){
   		  var sort_text = $(this).find('span').text();
          console.log('sort_text', sort_text);
          $('.sort-active-text span').text(sort_text);

        }
    	
  });
  $('#FacetFiltersForm').on('change', function(){
    setTimeout(function(){
        var c_url= location.href; 
        var sort_value = c_url.split('sort_by=');
        if( sort_value[1] == 'title-descending' ){
            $('[data-value="title-descending"]').find('input').val('title-ascending');
            option_value = $('[data-value="title-ascending"]').attr('data-value', 'title-descending');
            $('[data-value="title-ascending"]').addClass('active');
          }
        if( sort_value[1] == 'price-descending' ){
          $('[data-value="price-descending"]').find('input').val('price-ascending');
          option_value = $('[data-value="price-ascending"]').attr('data-value', 'price-descending');
          $('[data-value="price-ascending"]').addClass('active');
        }
        if( sort_value[1] == 'created-descending' ){
          $('[data-value="created-descending"]').find('input').val('created-ascending');
          option_value = $('[data-value="created-ascending"]').attr('data-value', 'created-descending');
          $('[data-value="created-ascending"]').addClass('active');
        }
        $('.custom-sort-item label').each(function(){
              var option_value = $(this).attr('data-value');
          	  //console.log(sort_value[1], option_value)
              if ( sort_value[1] == option_value){
                  $(this).addClass('active');
                // name
                if( sort_value[1] == 'title-ascending' ){
                    $(this).find('input').val('title-descending');
                    option_value = $(this).attr('data-value', 'title-descending');
                    $(this).addClass('active descending');
                   //console.log('aes')
                  }
                
                // price
                if( sort_value[1] == 'price-ascending' ){
                  $(this).find('input').val('price-descending');
                  option_value = $(this).attr('data-value', 'price-descending')
                  $(this).addClass('active descending');
                }
                // date
                if( sort_value[1] == 'created-ascending' ){
                  $(this).find('input').val('created-descending');
                  option_value = $(this).attr('data-value', 'created-descending')
                  $(this).addClass('active descending');
                }
               
              }
          if( $(this).hasClass('active')){
   			var sort_text = $(this).find('span').text();
			//console.log('sort_text', sort_text);
            $('.sort-active-text span').text(sort_text);

          }
          $('.addcart-caption .addcart-variant select').each(function(){
            var l_value = $(this).find('option').length;
            if( l_value == 1 ){
              $(this).addClass('only-one')
            }

          });
          	  
        })
    },1500)
      
  });
  
 //   variant length
  $('.addcart-caption .addcart-variant select').each(function(){
  	var l_value = $(this).find('option').length;
    if( l_value == 1 ){
      $(this).addClass('only-one')
    }
	
  });
  
  
  //   scroll animation text
  function isScrolledIntoView($elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $elem.offset().top;
    var elemBottom = elemTop + $elem.height();
    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }

  function count($this) {
    var current = parseInt($this.html(), 10);
    if (isScrolledIntoView($this) && !$this.data("isCounting") && current < $this.data('count')) {
      $this.html(++current);
      $this.data("isCounting", true);
      setTimeout(function () {
        $this.data("isCounting", false);
        count($this);
      }, 10);
    }
  }

  $(".animate-text-section .count").each(function () {
    $(this).data('count', parseInt($(this).html(), 10));
    //$(this).html('60');
    $(this).data("isCounting", false);
  });

  function startCount() {
    $(".animate-text-section .count").each(function () {
      count($(this));
    });
  };

  //$(window).scroll(function () {
    //startCount();
  //});

  //startCount();
  
  
  $('.custom-dropdown-box .variant-list li').on('click', function(){
    var product_id = $(this).parents('.custom-dropdown-box').attr('data-form');
  	var variant_id = $(this).attr('data-varaint-id');
    $(`#${product_id}`).find('input[name="id"]').val(variant_id);
    var variant_value = $(this).text();
    console.log(product_id, variant_id);
    $(this).siblings('li').removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.custom-dropdown-box').find('span.selected-value').text(variant_value);
    
  });
  
  //   variant change
  
  $('.product-custom-options input').on('change', function(e){
    	$('.product__info-wrapper input[name="id"]').val(e.target.value)
  });
  
  //   video js
//   $("#play_sound").click( function (){
//     if( $("#video").prop('muted') )
//     {
//         $("#video").prop('muted', false);
// 		$("#play_sound").addClass('mute');
//     }
//     else {
//     $("#video").prop('muted', true);
// 		$("#play_sound").removeClass('mute');
//     }
//   });
  
  // select js
//     if( $('.addresses .select').length > 0){
//       $('.addresses .select').select2();
//     }
  
  // select default contry
  setTimeout(function(){
  	$('#AddressCountryNew').select().val('Sweden');
  },1000);
  
  
  if($('.product-detail-video video').length > 0){
  	$('.product-detail-video video')[0].play();
  }
  if($('.product-list-video video').length > 0){
    $('.product-list-video video').each(function(){
    	$(this)[0].play()
    })
  	
  }
  if($('.featured-product-video video').length > 0){
  	$('.featured-product-video video')[0].play()
  }
  
  if($('.custom-product-image video').length > 0){
  	$('.custom-product-image video')[0].play()
  }
  
  
  
  $(".play-icon").click( function (){
    if( $(".play-icon").text() == 'PAUSE VIDEO' ){
      $('.article-video-banner video')[0].pause()	
      $(this).text('PLAY VIDEO');
      
    }else{
      $(this).text('PAUSE VIDEO');
      $('.article-video-banner video')[0].play();
      
    }
  	
  });
  
  
  // scroll element
  $(window).scroll(function(){
    if($('.progress-item-graph').length > 0){
      var wh= $(window).height();
      var progress_value = $('.progress-item-graph').offset().top - (wh/2);
      //console.log('progress_value', progress_value)
      if( $(window).scrollTop() > progress_value){
        $('.progress-item-graph').parents('.progress-list').addClass('progress-start');
      }
    }
  });
  
  $('.newsletter-form__button').on('click', function(){
    //console.log('type')
  	ValidateEmail(document.querySelector('.footer-block__newsletter .field__input'))
  });
  
  // email validation
  function ValidateEmail(inputText){
  	var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  	if(inputText.value.match(mailformat))
  	{
      return true;
  	}
 	else
    {
      $('.footer-block__newsletter .newsletter-error').text('You have entered an invalid email address')
      return false;
    }
  }
  
  // video scroll
  
  const registerVideo = (bound, video) => {
  	bound = document.querySelector(bound);
  	video = document.querySelector(video);
  	const scrollVideo = ()=>{
  		if(video.duration) {
  			const distanceFromTop = window.scrollY + bound.getBoundingClientRect().top;
  			const rawPercentScrolled = (window.scrollY - distanceFromTop + window.innerHeight/4) / (bound.scrollHeight - window.innerHeight);
  			const percentScrolled = Math.min(Math.max(rawPercentScrolled, 0), 2.5);
			
  			video.currentTime = video.duration * percentScrolled * 0.5;
            //console.log('percentScrolled', video.currentTime)
            
  		}
  		requestAnimationFrame(scrollVideo);
  	}
  	requestAnimationFrame(scrollVideo);
  }
  
  $(window).scroll(function(){
    if($('.info-list .info-item').length > 0){
        $('.info-list .info-item').each(function(){
          var wh = $(window).height();
          var st= $(window).scrollTop();
          var item_value = $(this).offset().top - wh;
          //console.log('st', st)
          if( st >  item_value) {
              $(this).addClass('active');
          }else{
            $(this).removeClass('active');
          }

        });
    }
  })
  
  
  if( $('.aw-wrapper').length > 0 ){
  	registerVideo(".aw-wrapper", ".aw-video video");
  }
  
  // update cart
 
  $(document).on('change','.cart-item-option select',function(e){
    e.preventDefault();
    $('.mini-cart').addClass('updating');
    var oldId = $(this).data('id');
    var id = $(this).val();
    var qty = $(this).data('quantity');
    
    var findQty = parseInt($('.cart-item-option select[data-id="'+ id +'"]').data('quantity'));
    if(findQty){
    	qty = qty + findQty;
    }
    
    $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
        id: parseFloat(oldId),
        quantity: 0,
      },
    }).then((data) => {
      updateItemToCart(id, qty);
    });
      
  });
  
  function updateItemToCart(id, qty) {

    var data = { updates: {} };
    data.updates[id] = qty;
    var cartUrl = $('body').data('currency');
    if(cartUrl != 'en-de'){
    	var ajaxUrl = '/' + cartUrl + '/cart';
    }else{
    	var ajaxUrl = '/cart';
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function() { 
        fetch(ajaxUrl).then(function(response) {
        	return response.text();
        }).then(function(html) {
        	
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var div = doc.querySelector('#main-cart-items');
          var subtotal = doc.querySelector('.totals__subtotal-value').textContent;
		  
          $('#cart').html(div);
          $('.totals__subtotal-value').text(subtotal);
          $('.mini-cart').removeClass('updating');
          });
      }
    });
  }
  
  // form validation
  
  $('#create_customer .form-btn').on('click', function(e){
  	e.preventDefault();
	
    var email = $('#RegisterForm-email').val();     
    
    var password = $('#RegisterForm-password').val();
    
    var term= $("input[type='checkbox'][name='customer[term]']:checked").length;
    var data_collection= $("input[type='checkbox'][name='customer[data-collection]']:checked").length;
    
    //console.log('data_collection', data_collection);
    if( email != '' && password != '' && term != 0 ){
       //return true;
      setTimeout(function(){
        $('.customer.register').addClass('success');
        $('.account-create-msg h4').text(`We've sent an activation email to ${email}. Please follow the instructions to start using your account`);
      	$('.account-create-msg').show();
      },1000);
      
      setTimeout(function(){
      	$('#create_customer').submit();
      },3000);
	   	
       
    }else{
      //return false;
      if(email == ''){
      	$('#RegisterForm-email').next('.error-msg').show();
      }else{
      	//$('#RegisterForm-email').next('.error-msg').hide();
        console.log('IsEmail(email)', IsEmail(email))
        if (IsEmail(email)==false){
            $('#RegisterForm-email').next('.error-msg').text('Enter Valid input');
            $('#RegisterForm-email').next('.error-msg').show();
        }else{
            
      		$('#RegisterForm-email').next('.error-msg').hide();
        }
      }
      if(password == ''){
      	$('#RegisterForm-password').next('.error-msg').show();
      }else{
      	$('#RegisterForm-password').next('.error-msg').hide();
      }
      
      if ( term == 0 ){
         $('#terms-conditions').parent('.radiobox').next('.error-msg').show();
      }else{
      	$('#terms-conditions').parent('.radiobox').next('.error-msg').hide();
      }
      
        //$('#terms-conditions').parent('.radiobox').next('.error-msg').text('Enter Valid input');
     
      
      return false;
    }
    
//     if ( term != 1 || data_collection != 1 ){
//     	//return true;
//     }else{
//         $('#terms-conditions').parent('.radiobox').next('.error-msg').show();
//     	return false;
//     }
//     if(IsEmail(email)==false){
//       $('#invalid_email').show();
//       return false;
//     }
    function IsEmail(email) {
        var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if(!regex.test(email)) {
           //return false;
          
          return false;
        }else{
          return true;
          
        }
      }
    
     //return true
  })
  
});
